<template>
  <img
    :src="require(`@/assets/wEB2-16.png`)"
    alt="arrow,nft,nft game,argons,solanart,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art"
    class="transition-transform duration-300 ease-in-out transform w-12"
    :class="[rotate, big ? 'scale-125' : 'scale-100']"
  />
</template>

<script>
export default {
  name: "arrowComponent",
  props: {
    direction: { type: String, default: "right" },
    big: { type: Boolean, default: false },
  },
  computed: {
    rotate() {
      switch (this.direction) {
        case "up":
          return "-rotate-90"
        case "down":
          return "rotate-90"
        case "left":
          return "rotate-180"
        default:
          return "rotate-0"
      }
    },
  },
}
</script>
